<template>
    <div class="sm:max-w-screen-xl w-full mx-auto mt-4 mb-24">
        <div>
            <div id="localStats" class="text-sm"></div>
            <div id="remoteStats"></div>
        </div>
        <div class="text-red-900 text-sm p-5 bg-red-200 border-2 border-red-400 rounded-md mt-5 hidden"
            id="error-container">
            <span id="errorMsg"></span>
        </div>
        <div>
            <div class="my-1 text-center hidden" id="requestMediaPermissionsWrapper">
                Microphone is <span id="micPermissionStatus" class="text-sm"></span>
                &bull;
                MIDI is <span id="midiPermissionStatus" class="text-sm"></span>
                <br />
                <button class="btn btn-secondary mt-5" id="requestMediaPermissions">Request permissions</button>
            </div>
        </div>
        <!-- Main wrapper for anywhere-->
        <div class="flex flex-wrap items-stretch justify-between" id="main">
            <div class="w-full px-5 mb-2">
                <button v-if="hasStarted == false" @click="pushToStart" class="w-full py-10 btn btn-primary">
                    <div>
                        Push to start
                    </div>
                </button>
            </div>
            <div class="w-full sm:w-1/2 lg:w-1/3 order-3 sm:order-1 px-2">
                <div>
                    <div class="flex justify-between items-baseline">
                        <div class="text-md font-semibold mt-3">
                            To Guests
                        </div>
                        <div class="pl-1 flex flex-wrap space-x-4 items-center">
                            <div>
                                Open mic
                            </div>
                            <div class="form-switch microphoneToggle muteMicrophone" data-id="microphone">
                                <input type="checkbox" checked>
                                <i class="!mr-0"></i>
                            </div>
                        </div>
                    </div>

                    <select class="audioSource form-input w-full mt-1" data-id="0"></select>
                    <div class="flex flex-wrap relative soundMeterMain">
                        <div class="led-wrapper">
                            <div class="led h-2"></div>
                        </div>
                    </div>

                    <div class="flex justify-between items-baseline">
                        <div class="text-md font-semibold mt-3">
                            To Talent
                        </div>
                        <div class="pl-1 flex flex-wrap space-x-4 items-center">
                            <div>
                                Open mic
                            </div>
                            <div class="form-switch microphoneToggle" data-id="talent">
                                <input type="checkbox" checked>
                                <i class="!mr-0"></i>
                            </div>
                        </div>
                    </div>
                    <select class="audioSource form-input w-full mt-1" data-id="2"></select>

                    <div class="flex flex-wrap relative" id="soundMeterTalent">
                        <div class="led-wrapper">
                            <div class="led h-2"></div>
                        </div>
                    </div>
                    <audio id="localAudio" class="hidden"></audio>
                    <audio id="localAudio2" class="hidden" muted></audio>
                    <audio id="localAudio3" class="hidden" muted></audio>
                    <div class="mt-4 flex flex-wrap  text-xs uppercase bold text-gray-600 tracking-wider hidden">
                        <div class="w-1/2 pl-3 flex flex-wrap justify-between items-center border-l border-gray-200">
                            HQS On
                            <div class="form-switch" id="toggleHQA">
                                <input type="checkbox" checked>
                                <i></i>
                            </div>
                        </div>
                    </div>
                    <hr class="my-5">
                    <div class="flex flex-wrap mt-5">
                        <div class="text-md font-semibold">
                            From Guests
                        </div>
                    </div>
                    <select class="audioOutput form-input w-full mt-1" data-id="0"></select>
                    <div class="flex justify-between mt-3">
                        <div class="text-md font-semibold">
                            From Talent 1
                        </div>
                        <div class="flex space-x-2">
                            <div class="text-gray-500 font-semibold" id="talent1Name"></div>
                            <div class="text-gray-500 font-light" id="talent1Latency"></div>
                        </div>
                    </div>
                    <select class="audioOutput form-input w-full mt-1" data-id="1"></select>
                    <div class="flex justify-between mt-3">
                        <div class="text-md font-semibold">
                            From Talent 2
                        </div>
                        <div class="flex space-x-2">
                            <div class="text-gray-500 font-semibold" id="talent2Name"></div>
                            <div class="text-gray-500 font-light" id="talent2Latency"></div>
                        </div>
                    </div>
                    <select class="audioOutput form-input w-full mt-1" data-id="2"></select>
                    <hr class="my-5">
                    <div class="mt-2 text-gray-700">
                        <sound-reactions class="w-full" custom-class="grid-cols-6" items-class="aspect-square"
                            :show-label="true"></sound-reactions>
                    </div>
                </div>
                <hr class="my-4 dark:border-gray-700" />
                <div class="">
                    <div class="text-lg font-medium">
                        My audio bitrate
                    </div>
                    <div class="text-xs uppercase bold text-gray-600 tracking-wider w-full">
                        <div class="flex items-baseline">
                            <input type="number" placeholder="0" v-model="selectedAudioBitrate" class="form-input">
                            <div class="flex-shrink-0 px-4">
                                in kbps
                            </div>
                        </div>
                        <div class="flex items-baseline">
                            <div class="w-full">
                                <input class="w-full" type="range" v-model="selectedAudioBitrate" min="6000" max="640000"
                                    @change="onChangeAudioBitrate" step="100">
                            </div>
                            <div class="flex-shrink-0 px-4">
                                in kbps
                            </div>
                        </div>
                    </div>
                    <div class="text-lg font-medium mt-5">
                        Others audio bitrate
                    </div>
                    <div class="text-xs uppercase bold text-gray-600 tracking-wider w-full">
                        <div class="flex items-baseline">
                            <input type="number" placeholder="0" v-model="selectedOthersAudioBitrate" class="form-input">
                            <div class="flex-shrink-0 px-4">
                                in kbps
                            </div>
                        </div>
                        <div class="flex items-baseline">
                            <div class="w-full">
                                <input class="w-full" type="range" v-model="selectedOthersAudioBitrate" min="6000"
                                    max="640000" @change="onChangeOthersAudioBitrate" step="100">
                            </div>
                            <div class="flex-shrink-0 px-4">
                                in kbps
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="w-full sm:w-1/2 lg:w-1/3 p-2 order-1 sm:order-2">
                <midi ref="midi"></midi>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3 order-2 lg:order-3 flex flex-col p-2">
                <div style="max-height: 18rem">
                    <div class="flex justify-between">
                        <div class="text-md font-semibold">
                            Connected Peers
                        </div>
                        <a rel="nofollow" @click="showParticipantsModal = true"
                            class="block text-blue-200 hover:bg-transparent rounded-md hover:text-blue-500 cursor-pointer underline text-right"
                            data-e2e="manage_test">
                            Manage participants
                        </a>
                    </div>
                    <anywhere-participant-list ref="participantList" :is-host="true"
                        style="min-height: 13rem;"></anywhere-participant-list>
                </div>
                <chat ref="chat"></chat>
                <div class="mt-8">
                    <label for="recordingNameInput" class="text-md font-semibold">Recording Name</label>
                    <div class="relative w-full">
                        <input type="text" id="recordingNameInput" class="form-input w-full mt-1"
                            placeholder="Type in the recording name">
                        <!-- Spinning semi-circle -->
                        <svg id="recordingNameLoading"
                            class="hidden absolute right-2 top-3.5  animate-spin h-5 w-5 text-blue-400"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                            </path>
                        </svg>
                    </div>
                    <div class="flex flex-wrap mt-2">
                        <div class="w-full">
                            <button class="btn btn-red w-full" id="recordAll">
                                <div class="recording hidden">Recording...press to stop</div>
                                <div class="not-recording">
                                    REC - Record all talent
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

                <div id="re" class="bg-gray-100">
                </div>

                <div class="w-full p-2 grow">
                    <div class="flex justify-between items-center">
                        <div class="text-md font-semibold">
                            Backup audio files
                        </div>
                        <div>
                            <button @click="downloadAllRecordings"
                                class="underline text-xs text-gray-700 hover:text-blue-500">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    class="inline-block w-3 mr-2" viewBox="0 0 20 20">
                                    <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
                                </svg>
                                Download all
                            </button>
                        </div>
                    </div>
                    <div class="new-audio-files bg-gray-100 rounded-md h-full">
                        <div id="new-recordings" class="h-96 overflow-scroll">
                            <div :id="'recording_' + recording.id" class="mt-5" v-for="recording in recordings">
                                <div class="w-full px-5">
                                    <div class="flex flex-wrap justify-between">
                                        <div class="flex flex-wrap">
                                            <button @click="wavePlayPauseRecording(recording.id)"
                                                class="btn btn-secondary playButton rounded-sm p-2">
                                                <div class="hidden label">Play</div>
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    class="playIcon w-8 text-white fill-current" viewBox="0 0 20 20">
                                                    <path d="M4 4l12 6-12 6z" />
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    class="pauseIcon hidden w-8 text-white fill-current"
                                                    viewBox="0 0 20 20">
                                                    <path d="M5 4h3v12H5V4zm7 0h3v12h-3V4z" />
                                                </svg>
                                            </button>
                                            <div class="ml-5">
                                                <div class="font-medium">{{ recording.name }}</div>
                                                <div class="">
                                                    <a :href="recording.file_url" target="_blank"
                                                        class="underline text-xs text-gray-700 hover:text-blue-500">
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            class="inline-block w-3 mr-2" viewBox="0 0 20 20">
                                                            <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
                                                        </svg>
                                                        Download
                                                    </a>
                                                </div>
                                                <audio :id="'audio_' + recording.id" class="talent_recording_audio hidden" :src="recording.file_url"></audio>
                                            </div>
                                        </div>
                                        <div>
                                            {{ recording.date }}
                                        </div>
                                    </div>
                                    <div :id="'waveform_' + recording.id" class="py-2 px-2"></div>
                                    <hr class="border border-gray-200 w-full mt-0">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modals -->
        <modal :showModal="showParticipantsModal" @close="showParticipantsModal = false" classSize="sm:max-w-2xl">
            <manage-participants @close-modal="showParticipantsModal = false" :room="room" :roles="roles"
                :is-in-trial="false"></manage-participants>
        </modal>
    </div>
</template>
<script>
import commandsManager from 'general/CommandsManager'
import WaveSurfer from "wavesurfer.js";
import messageBroker from 'general/messageBroker'

function updateAudioList(data) {
    console.log("New audio file", data);
    if (vm.$refs.orchestrator == null) {
        console.warn("No orchestrator found");
        return;
    }
    vm.$refs.orchestrator.addRecording(data);
}
window.updateAudioList = updateAudioList;

function drawAllWavesurfers(waveRecordings) {
    for (const [key, value] of Object.entries(waveRecordings)) {
        drawWavesurfer(key, waveRecordings[key].url);
    }
}

function drawWavesurfer(id, url) {
    $(`#waveform_${id}`).html("");
    const wavesurfer = WaveSurfer.create({
        container: `#waveform_${id}`,
        waveColor: "#4fd1c5",
        progressColor: "#319795",
        height: 40,
        barWidth: 2,
        barRadius: 2,
        barGap: 1,
        barHeight: 2, // the height of the wave
        cursorColor: "#319795",
        cursorWidth: 3,
        hideScrollbar: true,
    });
    wavesurfer.load(url);
    if (vm.$refs.orchestrator == null) {
        console.warn("No orchestrator found");
        return;
    }
    vm.$refs.orchestrator.waveRecordings[id] = { url, wavesurfer };
}

export default {
    props: {
        room: {},
        roles: {
            type: Array
        },
    },
    data() {
        return {
            hasStarted: false,
            showParticipantsModal: false,
            selectedAudioBitrate: 32 * 1000,
            selectedOthersAudioBitrate: 32 * 1000,
            recordings: [],
            waveRecordings: {},

        }
    },
    mounted() {
        messageBroker.registerNewMessageType('session_info', (data) => {
            if (data.message.isRecording){
                // get current time from MIDI comonent
            }
        });



        commandsManager.registerNewCommand('anywhere--set-audio-bitrate', (bitrate) => {
            this.selectedOthersAudioBitrate = bitrate;
        });
        const recordingNameInput = document.querySelector("#recordingNameInput");
        if (recordingNameInput == null) {
            console.warn("No recording name input found");
        } else {
            const recordingNameLoading = document.querySelector("#recordingNameLoading");
            let recordingNameTimeout;
            recordingNameInput.value = "Recording";
            recordingNameInput.addEventListener("keyup", (event) => {
                const message = event.target.value; // save sended message
                if (message == null || message == "") return;
                recordingNameLoading.classList.remove("hidden");

                clearTimeout(recordingNameTimeout);
                recordingNameTimeout = window.setTimeout(() => {
                    commandsManager
                        .getCommandById("anywhere--set_recording_name")
                        .sendToRole("talent", { message });
                    recordingNameLoading.classList.add("hidden");
                }, 1000);
            });
        }

    },
    methods: {
        wavePlayPauseRecording(id) {
            const playButton = $(`#recording_${id} .playButton`);
            const playIcon = $(`#recording_${id} .playButton .playIcon`);
            const pauseIcon = $(`#recording_${id} .playButton .pauseIcon`);
            const audio = document.querySelector(`#audio_${id}`);
            if (playButton.text().trim() == "Play") {
                if(audio) {
                    audio.play();
                    audio.onended = () => {
                        this.wavePlayPauseRecording(id);
                    }
                }
                // this.waveRecordings[id].wavesurfer.play();
                playIcon.addClass("hidden");
                pauseIcon.removeClass("hidden");
                playButton.children(".label").html("Pause");
                // this.waveRecordings[id].wavesurfer.on("finish", () => {
                //     this.wavePlayPauseRecording(id);
                //     this.waveRecordings[id].wavesurfer.un("finish");
                // });
            } else {
                if(audio) audio.pause();
                // this.waveRecordings[id].wavesurfer.pause();
                playButton.children(".label").html("Play");
                playIcon.removeClass("hidden");
                pauseIcon.addClass("hidden");
            }
        },
        downloadRecording(i) {
            const recording = this.recordings[i]
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = recording.file_url;
            a.download = recording.name;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
            }, 100);
        },
        downloadAllRecordings(){
            this.recordings.forEach((recording, i) => {
                this.downloadRecording(i)
            });
        },
        addRecording(data) {
            this.recordings.push(data);
            this.waveRecordings[data.id] = { url: data.file_url };

            window.changeAudioDestination() // update audio routing
            // give a little time for the DOM to update (to create the container needed to draw the wave)
            window.setTimeout(()=>{
                drawAllWavesurfers(this.waveRecordings);
            }, 1000)
        },
        pushToStart() {
            this.hasStarted = true;
            // start WebAudio
            startSoundMeterContext()
            // START WEBRTC
            setupEngine('anywhere', 'host', window.name, window.participant_key, window.room_key);

            window.setTimeout(()=>{
                if (vm.$refs.orchestrator){
                    vm.$refs.orchestrator.$refs.participantList.showActions = true;
                }
            }, 2000)
            document.getElementById("soundBar6").play()
            $(".form-switch").click(() => {
                let switchSound = document.getElementById("switchOnSound");
                switchSound.volume = 0.2;
                switchSound.play()
            })
        },
        // Start updating the MIDI timecode in the black box
        onChangeAudioBitrate() {
            if (manager && manager.rtc) {
                manager.rtc.SetBitrateForAudio(Math.max(this.selectedAudioBitrate, 6000)); // minimum bitrate is 6000
            }
        },
        onChangeOthersAudioBitrate() {
            if (manager && manager.rtc) {
                // send a command to everyone telling them to change the audiobitrate
                commandsManager.sendAllCommand('anywhere--set-audio-bitrate', this.selectedOthersAudioBitrate);
            }
        },

    }
}

</script>
<style lang="scss"></style>